import { PickSessionSchema } from "@redotech/redo-model/wms/schema/pick-session";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

const PickSessionItemStatusInputSchema = z.object({
  fulfillmentOrderLineItemExternalId: z.string(),
  quantityPicked: z.number(),
});

export const markFulfillmentGroupAsProblem = {
  name: "markFulfillmentGroupAsProblem" as const,
  input: z.object({
    pickSessionId: zExt.objectId(),
    fulfillmentGroupId: zExt.objectId(),
    pickSessionItemStatuses: z
      .array(PickSessionItemStatusInputSchema)
      .nullish(),
  }),
  output: z.object({
    success: z.boolean(),
    message: z.string().nullish(),
    updatedPickSession: PickSessionSchema.nullish(),
  }),
};
